// @ts-ignore
import LegacyNavigationBar from "@fdr/mobile-footer";
import React, { memo, useContext, useMemo } from "react";
import { useSelector } from "react-redux";
import { getIsLogged } from "@urp/store-selectors";
import type { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import ApolloContext from "@tvg/utils/apolloContext";
import { isAccountCompliantSelector } from "@tvg/sh-utils/sessionUtils";
import { getTodayActiveCounter } from "@tvg/sh-lib-my-bets/redux/selectors";
import { buildQaLabel } from "@tvg/test-utils/utils";
import { useLocation, useNavigate } from "react-router";
import NavigationBar from "../NavigationBar";
import type { Props } from "./types";
import {
  getBalanceShown,
  getIsPromosEnabled,
  getNoLoginRequired,
  isURPFooterEnabled
} from "../../redux/selectors";
import { parseRoutesToNavItems } from "./utils";
import { Container } from "./styled-components";
import JoinBar from "../JoinBar";
import { CONTAINER, FOOTER } from "../../constants";

const Footer = ({
  routes,
  isJoinBarVisible = true,
  isVisible = true,
  qaLabel = ""
}: Props) => {
  // SELECTORS
  const isLogged = useSelector(getIsLogged);
  const isFooterRedesignEnabled = useSelector(isURPFooterEnabled);
  const isNoLoginRequired = useSelector(getNoLoginRequired);
  const isPromosEnabled = useSelector(getIsPromosEnabled);
  const isBalanceShown = useSelector(getBalanceShown);
  const isAccountCompliant = useSelector(isAccountCompliantSelector);

  const counter = useSelector(getTodayActiveCounter);

  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const { behgClient } =
    useContext<{ behgClient?: ApolloClient<NormalizedCacheObject> }>(
      ApolloContext
    );

  const currentPath = `${pathname}${search}`;
  const showBalance = isBalanceShown === "1";

  const footerItems = useMemo(
    () =>
      parseRoutesToNavItems(
        routes,
        isPromosEnabled,
        currentPath,
        navigate,
        isLogged,
        isNoLoginRequired,
        showBalance,
        isAccountCompliant,
        counter
      ),
    [
      isPromosEnabled,
      isLogged,
      isAccountCompliant,
      showBalance,
      currentPath,
      counter
    ]
  );

  if (!isVisible) return null;

  return (
    <Container data-qa-label={buildQaLabel([qaLabel, FOOTER, CONTAINER])}>
      <JoinBar
        qaLabel={buildQaLabel([qaLabel, FOOTER])}
        isVisible={isJoinBarVisible}
      />

      {isFooterRedesignEnabled ? (
        <NavigationBar
          items={footerItems}
          qaLabel={buildQaLabel([qaLabel, FOOTER])}
        />
      ) : (
        <LegacyNavigationBar
          isLogged={isLogged}
          links={footerItems}
          activePath={currentPath}
          isVisible={isVisible}
          behgClient={behgClient}
          isPromosEnabled={isPromosEnabled}
          noLoginRequiredForAccountPage={isNoLoginRequired}
        />
      )}
    </Container>
  );
};

export default memo(Footer);
